import { render } from "./TableSplitCell.vue?vue&type=template&id=f1454a2c"
import script from "./TableSplitCell.vue?vue&type=script&lang=js"
export * from "./TableSplitCell.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TableSplitCell.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1454a2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1454a2c', __exports__)) {
    api.reload('f1454a2c', __exports__)
  }
  
  module.hot.accept("./TableSplitCell.vue?vue&type=template&id=f1454a2c", () => {
    api.rerender('f1454a2c', render)
  })

}


export default __exports__